import Vue from 'vue';
import { formatDate } from '@/util/global';

Vue.filter('date_format', (value: number) => {
  if (!value) return '';
  return formatDate(value);
});
